import { useParams } from "react-router-dom";
import { drcr, useBooks } from "@/lib/books";
import { Loaded, PageHeader } from "@/components/books/ui";
import { LedgerStatement, usePeriod } from "@/components/books/Statement";

/** One ledger: where it sits and its statement for the chosen period. */
export default function LedgerPage() {
  const { guid } = useParams();
  const [period, setPeriod, fyMonth] = usePeriod("this_fy");
  const ledger = useBooks(`/books/ledgers/${guid}`);
  return (
    <div className="max-w-6xl">
      <Loaded state={ledger}>
        {ledger.data && (
          <PageHeader kicker={[ledger.data.section, ledger.data.parent].filter(Boolean).join(" › ") || "Ledger"}
            title={ledger.data.name}
            subtitle={`Balance today ${drcr(ledger.data.balance)}${ledger.data.gstin ? ` · GSTIN ${ledger.data.gstin}` : ""}`} />
        )}
      </Loaded>
      <LedgerStatement guid={guid} period={period} setPeriod={setPeriod} fyMonth={fyMonth} />
    </div>
  );
}
